import { flatten } from 'lodash';
import { ReactEditor } from 'slate-react';

import { SlateDocumentFragment } from '../../../../slatePlugins/common/types/SlateDocument.types';
import { DEFAULTS_LIST } from '../../../../slatePlugins/elements/list/defaults';
import { DEFAULTS_PARAGRAPH } from '../../../../slatePlugins/elements/paragraph/defaults';
import { isBlockActive } from '../../helpers';

const wrapParagraphUnderListItem = (fragment) => {
  if (fragment) {
    return flatten(
      fragment
        .map((item) => {
          let mappedItem = item;
          if (item && item.type === DEFAULTS_PARAGRAPH.p.type) {
            mappedItem = item.children;
          } else if (item && item.text && item.text.trim().length === 0) {
            mappedItem = null; // ignore empty text node
          }
          return mappedItem;
        })
        .filter((item) => !!item)
    );
  }
  return [];
};

export const normalizeListItemOnPaste = <T extends ReactEditor>(
  fragment: SlateDocumentFragment,
  editor: T
) => {
  if (isBlockActive(editor, DEFAULTS_LIST.li.type)) {
    return wrapParagraphUnderListItem(fragment);
  }
  return fragment;
};
